import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';

import { Menu } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { EmptyHeader } from 'components';

import {
  selectors,
  logout,
  TRADING_WINDOWS,
  HISTORICAL_SCENARIO,
  CREATING,
} from 'state';
import { CountdownTimer } from '../../components/Charts/CountdownTimer';

const MyHeader: React.FC = () => {
  const dispatch = useDispatch();
  const username = useSelector(selectors.username);
  const { trading_time_type, next_historical_period_task_time, status } =
    useSelector(selectors.activeSession);
  const session = useSelector(selectors.activeSession);
  const { url } = useRouteMatch();
  const showCentralBank =
    session.scenario_type === HISTORICAL_SCENARIO &&
    session.status !== CREATING &&
    session.show_auctions;
  // Legacy Analysis tab is retired — never show the menu item, regardless of
  // show_analysis_tab. (Page code kept under Analysis/.)
  const canAccessAnalysis = false;
  const canAccessAnalysisStudio = session.show_analysis_studio_tab;

  return (
    <EmptyHeader defaultKey="graph" home={`${url}`}>
      <Menu.Item key="overview">
        <Link to={`${url}/overview`}>Overview</Link>
      </Menu.Item>
      {showCentralBank && (
        <Menu.Item key="central-bank">
          <Link to={`${url}/central-bank`}>Central Bank</Link>
        </Menu.Item>
      )}
      {/* Old Session Settings — hidden from the navbar; still reachable by
          typing /old-settings (fallback if the new tab misbehaves). */}
      {/*<Menu.Item key="old-settings">*/}
      {/*  <Link to={`${url}/old-settings`}>Session Settings (old)</Link>*/}
      {/*</Menu.Item>*/}
      <Menu.Item key="session-settings">
        <Link to={`${url}/session-settings`}>Session Settings</Link>
      </Menu.Item>
      {/*<Menu.Item key="benchmarks">*/}
      {/*  <Link to={`${url}/benchmarks`}>Benchmarks</Link>*/}
      {/*</Menu.Item>*/}
      {trading_time_type === TRADING_WINDOWS && (
        <Menu.Item key="trading-intervals">
          <Link to={`${url}/trading-intervals`}>Trading Windows</Link>
        </Menu.Item>
      )}
      {/*<Menu.Item key="settings">*/}
      {/*  <Link to={`${url}/settings`}>Settings</Link>*/}
      {/*</Menu.Item>*/}
      <Menu.Item key="performance">
        <Link to={`${url}/performance`}>Performance</Link>
      </Menu.Item>
      <Menu.Item key="assessment">
        <Link to={`${url}/assessment`}>Assessment</Link>
      </Menu.Item>
      {canAccessAnalysis && (
        <Menu.Item key="analysis">
          <Link to={`${url}/analysis`}>Analysis</Link>
        </Menu.Item>
      )}
      {/* Live-wired version of the studio (real session data). */}
      {canAccessAnalysisStudio && (
        <Menu.Item key="analysis-studio">
          <Link to={`${url}/analysis-studio`}>Analysis Studio</Link>
        </Menu.Item>
      )}
      {/* {session.show_ai_tab && (
        <Menu.Item key="ai">
          <Link to={`${url}/ai`}>AI (Beta)</Link>
        </Menu.Item>
      )} */}
      {/* Macro Background moved into the Settings3 sidecar selector. */}
      {/*<Menu.Item key="instruments">*/}
      {/*  <Link to={`${url}/instruments`}>Instruments</Link>*/}
      {/*</Menu.Item>*/}
      <Menu.Item style={{ marginLeft: 'auto' }}>
        {next_historical_period_task_time !== null ? (
          <CountdownTimer
            runAtIso={next_historical_period_task_time}
            status={status}
          />
        ) : (
          <span></span>
        )}
      </Menu.Item>
      <Menu.SubMenu
        title={
          <>
            <UserOutlined />
            {username}
          </>
        }
      >
        <Menu.Item>
          <Link to={`/dashboard`}>Exit session</Link>
        </Menu.Item>
        <Menu.Item onClick={() => dispatch(logout({}))}>Logout</Menu.Item>
      </Menu.SubMenu>
    </EmptyHeader>
  );
};

export default MyHeader;
